/*
 * Copyright (c) 2026. Bluemate B.V.
 */

import React, {useEffect, useState} from 'react';

import NotificationInput from './notificationInput';
import {NumberString} from '@dvrd/dvr-controls';

interface Props<T extends number | string | NumberString> {
    onSubmit: (value: T) => void;
    value: T;
    label: string;
    disabled?: boolean;
    inputProps?: Record<string, any>;
}

export default function NotificationInputController<T extends number | string | NumberString>(props: Props<T>) {
    const {label, inputProps, disabled} = props;
    const [value, setValue] = useState<T>(props.value);
    const [active, setActive] = useState(false);

    function onActivate() {
        setActive(true);
    }

    function onClose() {
        setActive(false);
    }

    function onChange(value: T) {
        setValue(value);
    }

    function onSubmit() {
        props.onSubmit(value);
        onClose();
    }

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <NotificationInput
            onActivate={onActivate}
            onClose={onClose}
            onChange={onChange}
            onSubmit={onSubmit}
            value={value}
            label={label}
            active={active}
            inputProps={inputProps}
            disabled={disabled}
            parentValue={props.value}
        />
    );
}
